import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import {
  APP_BACKGROUND_VARIANTS,
  DEFAULT_BACKGROUND_VARIANT,
  normalizeBackgroundVariant,
} from '../constants/appBackgroundVariants';

const BackgroundVariantContext = createContext(null);

export const BackgroundVariantProvider = ({ children }) => {
  const [variant, setVariantState] = useState(DEFAULT_BACKGROUND_VARIANT);

  const setVariant = useCallback((nextVariant) => {
    setVariantState((prev) => {
      const normalized = normalizeBackgroundVariant(nextVariant);
      return prev === normalized ? prev : normalized;
    });
  }, []);

  const value = useMemo(() => ({
    variant,
    setVariant,
    availableVariants: APP_BACKGROUND_VARIANTS,
  }), [variant, setVariant]);

  return (
    <BackgroundVariantContext.Provider value={value}>
      {children}
    </BackgroundVariantContext.Provider>
  );
};

export const useBackgroundVariant = () => {
  const context = useContext(BackgroundVariantContext);
  if (!context) {
    throw new Error('useBackgroundVariant must be used within a BackgroundVariantProvider');
  }
  return context;
};
